import { loadSlim } from '@tsparticles/slim';
import { loadImageShape } from '@tsparticles/shape-image';

/** Khởi tạo engine một lần cho ParticlesProvider (@tsparticles/react v4) */
export async function initParticlesEngine(engine) {
    await loadSlim(engine);
    await loadImageShape(engine);
}
